import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Brain, GraduationCap, ClipboardCheck, Settings, QrCode, ArrowRight, ShieldCheck } from "lucide-react";

const cards = [
  { icon: GraduationCap, title: "Alumno", desc: "Ingresa con tu matrícula, elige un ejercicio y practica la entrevista clínica.", to: "/login", testid: "enter-student", cta: "Entrar como alumno" },
  { icon: ClipboardCheck, title: "Supervisor", desc: "Revisa diálogos, busca por ID o matrícula y califica con rúbrica.", to: "/staff", testid: "enter-supervisor", cta: "Acceso staff" },
  { icon: Settings, title: "Administrador", desc: "Configura pacientes virtuales, ejercicios, reglas y consulta la auditoría.", to: "/staff", testid: "enter-admin", cta: "Acceso staff" },
];

export default function Landing() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border bg-white">
        <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-6">
          <div className="flex items-center gap-3">
            <div className="flex h-9 w-9 items-center justify-center rounded-md bg-primary text-primary-foreground">
              <Brain className="h-5 w-5" />
            </div>
            <p className="font-display text-sm font-bold">Centro de Psicoterapia Cognitiva</p>
          </div>
          <Button variant="outline" onClick={() => navigate("/verify")} data-testid="nav-verify-button">
            <QrCode className="mr-2 h-4 w-4" />Verificar documento
          </Button>
        </div>
      </header>

      <section className="mx-auto max-w-6xl px-6 py-16 sepp-fade">
        <div className="max-w-3xl">
          <p className="mb-3 inline-flex items-center gap-2 rounded-full border border-primary/20 bg-primary/5 px-3 py-1 text-xs font-medium uppercase tracking-wider text-primary">
            <ShieldCheck className="h-3.5 w-3.5" /> Entrevistas clínicas simuladas · Trazabilidad completa
          </p>
          <h1 className="font-display text-4xl font-bold tracking-tight text-foreground sm:text-5xl">
            Practica entrevistas clínicas con un paciente virtual configurable.
          </h1>
          <p className="mt-5 text-base leading-relaxed text-muted-foreground sm:text-lg">
            Plataforma educativa para que los alumnos entrenen la entrevista psicológica con casos definidos por el
            equipo docente. Cada diálogo se guarda, se exporta a PDF y se verifica por QR + PIN.
          </p>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {cards.map((c) => (
            <div key={c.title} className="group rounded-xl border border-border bg-card p-6 transition-shadow hover:shadow-lg">
              <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary/10 text-primary">
                <c.icon className="h-5 w-5" />
              </div>
              <h3 className="mt-4 font-display text-lg font-semibold">{c.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{c.desc}</p>
              <Button
                variant="ghost"
                className="mt-4 px-0 text-primary hover:bg-transparent hover:text-primary"
                onClick={() => navigate(c.to)}
                data-testid={c.testid}
              >
                {c.cta} <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
              </Button>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
